import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import Input from 'components/Form/Input';
import Validator from 'components/Validator/Validator';
import { Button } from 'components/Button';
import { updateDebitCard } from 'actions/quickpay';
import { get } from 'lodash';
import updateDebitCardSchema from './schemas/updateDebitCardSchema';
import styles from './styles.module.scss';

const UpdateDebitCard = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const { paymentAccountId } = useParams();
  const uid = useSelector((state) => state.quickpay.uid);
  const quickpayData = useSelector((state) => state.quickpay.data);
  const {
    validator: {
      values,
      errors,
      setValues,
      validate,
    },
  } = props;

  const handleInputChange = (event) => {
    const { onChangeHandler } = props.validator;
    onChangeHandler(event.target.name, event.target.value);
  };

  useEffect(() => {
    if (paymentAccountId) {
      const paymentAccountInfo = (quickpayData?.paymentAccounts || []).filter((paymentAccount) => paymentAccount.accountId === paymentAccountId);
      if (paymentAccountInfo && paymentAccountInfo.length > 0 && paymentAccountInfo[0].cardNumberLast4) {
        setValues({
          ...values,
          accountNumber: `xxxx-xxxx-xxxx-${paymentAccountInfo[0].cardNumberLast4}`,
        });
      } else {
        setErrorMsg('Debit Card not found');
      }
    } else {
      setErrorMsg('Payment account id missing!');
    }
  }, [paymentAccountId]);

  const handleFail = (error) => {
    setErrorMsg(get(error, 'data.errorMessages[0]') || get(error, 'data.message') || 'An error occurred');
    setIsLoading(false);
  };

  const goToSimplePay = (e) => {
    e.preventDefault();
    if (uid) {
      navigate({
        pathname: `/quickpay/${uid}`,
        state: {
          from: 'quickpay/simple-pay',
        },
      });
    }
  };

  const handleUpdateDebitCard = () => {
    setErrorMsg('');

    const schema = updateDebitCardSchema;
    if (!validate(schema).isValid) {
      setErrorMsg('Invalid input. Please check your details.');
      return;
    }

    setIsLoading(true);

    const data = {
      expirationDate: {
        month: values.expirationDate.split('/')[0] || '',
        year: values.expirationDate.split('/')[1] || '',
      },
    };

    dispatch(
      updateDebitCard({
        paymentAccountId,
        data,
        success: () => {
          navigate('/quickpay/simple-pay');
        },
        fail: handleFail,
      })
    );
  };

  return (
    <div className={styles.quickpay}>
      <div className={cn(styles.content, 'text-center')}>
        <h2>
          Hey
          {' '}
          {quickpayData.firstName}
          !
        </h2>
        <h1 className="mb-2">Update Debit Card</h1>
        {errorMsg !== 'Debit Card not found' ? (
          <div>
            <Input
              labelClassName="mb-2"
              name="accountNumber"
              label="Account Number"
              inputMode="numeric"
              value={values.accountNumber}
              onChange={handleInputChange}
              placeHolder="Account Number"
              isBadgeVisible={false}
              disabled
            />
            <Input
              name="expirationDate"
              label="Expiration Date"
              onChange={handleInputChange}
              value={values.expirationDate || ''}
              isMasked={[/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
              isRequired
              hasError={!!errors.expirationDate}
              errorMessage={errors.expirationDate}
              placeHolder="MM/YYYY"
              inputMode="numeric"
            />
            {errorMsg ? (
              <div className={styles.error}>
                {errorMsg}
              </div>
            ) : null}
          </div>
        ) : (
          <div className={styles.error}>
            {errorMsg}
          </div>
        )}
      </div>
      <div className={styles.stickyFooter}>
        <Button
          color="primary"
          className="w-100 mt-1"
          onClick={handleUpdateDebitCard}
          isLoading={isLoading}
          isDisabled={errorMsg === 'Debit Card not found'}
        >
          Update Debit Card
        </Button>

        <span
          className={`${styles.anchorBtn} mt-1 d-block`}
          onClick={goToSimplePay}
        >
          Cancel
        </span>
      </div>
    </div>
  );
};

UpdateDebitCard.propTypes = {
  validator: PropTypes.object.isRequired,
};

export default compose(Validator())(UpdateDebitCard);
